import styled from "styled-components";

import { TabsMenuStyledProps as Props } from "./TabsMenu.types";

const TabsMenuStyled = styled.div<Props>`
  .TabsMenu {
    &__tabs {
      background-color: var(--palette-black-s2-l17) !important;
      padding-top: 2rem;
    }

    &__tabs {
      &__item {
        min-width: 6rem;
      }
    }

    &__bar {
      background-color: var(--palette-black-s2-l17) !important;
      padding-bottom: 0.8rem;
    }
  }
`;

export default TabsMenuStyled;
